import { render, staticRenderFns } from "./DispatchOrders.vue?vue&type=template&id=f6d0fbc4&"
import script from "./DispatchOrders.vue?vue&type=script&lang=js&"
export * from "./DispatchOrders.vue?vue&type=script&lang=js&"
import style0 from "./DispatchOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports